import { render, staticRenderFns } from "./inadmissible.vue?vue&type=template&id=3de218d6&scoped=true"
import script from "./inadmissible.vue?vue&type=script&lang=js"
export * from "./inadmissible.vue?vue&type=script&lang=js"
import style0 from "./inadmissible.vue?vue&type=style&index=0&id=3de218d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de218d6",
  null
  
)

export default component.exports